import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Bill } from '../model/bill.model';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-bill-date-dialog',
  templateUrl: './bill-date-dialog.component.html',
  styleUrls: ['./bill-date-dialog.component.scss'],
})
export class BillDateDialogComponent {
  bill: Bill;
  newBillDate: string = '';
  isSaving = false;

  constructor(
    public dialogRef: MatDialogRef<BillDateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { bill: Bill },
    private apiService: ApiService,
    private _snackBar: MatSnackBar
  ) {
    this.bill = data.bill;
    this.newBillDate = this.bill.billDate;
  }

  save(): void {
    if (!this.newBillDate) {
      this._snackBar.open('Please pick a bill date', 'Close', { duration: 2000 });
      return;
    }
    const body = {
      billDate: this.newBillDate,
      billPaidDate: this.bill.billPaidDate,
    };
    this.isSaving = true;
    this.apiService.updateBillDates(this.bill.billNumber, body).subscribe(
      (res: any) => {
        this.isSaving = false;
        if (res && res.isSuccess) {
          this._snackBar.open('Bill date updated', 'Close', { duration: 2000 });
          this.dialogRef.close(this.newBillDate);
        } else {
          this._snackBar.open('Update failed', 'Close', { duration: 2000 });
        }
      },
      () => {
        this.isSaving = false;
        this._snackBar.open('Update failed', 'Close', { duration: 2000 });
      }
    );
  }

  close(): void {
    this.dialogRef.close();
  }
}
